import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PageHome" }
const _hoisted_2 = { class: "content-home" }
const _hoisted_3 = {
  class: "content-home__container",
  style: { minHeight: '1000px' }
}
const _hoisted_4 = {
  class: "content-home__container content-home__exited-slider",
  style: { minHeight: '750px' }
}
const _hoisted_5 = {
  class: "content-home__container",
  style: { minHeight: '600px' }
}
const _hoisted_6 = {
  class: "content-home__container",
  style: { minHeight: '1100px' }
}
const _hoisted_7 = {
  class: "content-home__container",
  style: { minHeight: '650px' }
}
const _hoisted_8 = {
  class: "content-home__container",
  style: { minHeight: '550px' }
}
const _hoisted_9 = {
  class: "content-home__container",
  style: { minHeight: '300px' }
}

import { defineAsyncComponent, onMounted } from 'vue';
import LayoutMain from 'Layouts/LayoutMain.vue';
import { dispatchRenderReady } from 'Pages/utils/render';
import { useLoginRedirectDefault } from 'Composables/useLoginRedirectDefault';
import ControlRender from '@/components/ControlRender/ControlRender.vue';
import BaseSkeleton from 'Components/Base/BaseSkeleton';
import { usePageSeo } from '../сomposables';

import ContentHomeHeader from './components/ContentHomeHeader.vue';
import ContentHomeTrackrecord from './components/ContentHomeTrackrecord.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHome',
  setup(__props) {

const ContentHomeWhyFarmland = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeWhyFarmland' */ './components/ContentHomeWhyFarmland.vue'),
  loadingComponent: BaseSkeleton,
});
const ExitedInvestmentsSlider = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ExitedInvestmentsSlider' */ 'Components/ExitedInvestmentsSlider/ExitedInvestmentsSlider.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeWhyAcreTrader = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeWhyAcreTrader' */ './components/ContentHomeWhyAcreTrader.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeHowItWorks = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeHowItWorks' */ './components/ContentHomeHowItWorks'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeForFarmers = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeForFarmers' */ './components/ContentHomeForFarmers.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeAboutInvestingFarmland = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeAboutInvestingFarmland' */ './components/ContentHomeAboutInvestingFarmland.vue'),
  loadingComponent: BaseSkeleton,
});
const ContentHomeReadyToGetStarted = defineAsyncComponent({
  loader: () => import(/* webpackChunkName: 'ContentHomeReadyToGetStarted' */ './components/ContentHomeReadyToGetStarted.vue'),
  loadingComponent: BaseSkeleton,
});

const { setPageTitle } = usePageSeo();

onMounted(() => {
  setPageTitle();
  setTimeout(() => dispatchRenderReady(), 10000);
});

async function onPopupLoggedIn() {
  await useLoginRedirectDefault().redirectOnLoginDefault();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LayoutMain, {
      "redirect-on-login": "default",
      onPopupLoggedIn: onPopupLoggedIn
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ContentHomeHeader),
          _createVNode(ContentHomeTrackrecord, { class: "content-home__trackrecord" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ControlRender, {
              "when-visible": "",
              timeout: 5000,
              "when-prerender": "",
              "visibility-top-margin": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ContentHomeWhyFarmland))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ControlRender, {
              "when-visible": "",
              timeout: 5000,
              "when-prerender": "",
              "visibility-top-margin": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ExitedInvestmentsSlider))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ControlRender, {
              "when-visible": "",
              timeout: 5000,
              "when-prerender": "",
              "visibility-top-margin": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ContentHomeWhyAcreTrader))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(ControlRender, {
              "when-visible": "",
              timeout: 5000,
              "when-prerender": "",
              "visibility-top-margin": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ContentHomeHowItWorks))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(ControlRender, {
              "when-visible": "",
              timeout: 5000,
              "when-prerender": "",
              "visibility-top-margin": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ContentHomeForFarmers))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(ControlRender, {
              "when-visible": "",
              timeout: 5000,
              "when-prerender": "",
              "visibility-top-margin": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ContentHomeAboutInvestingFarmland))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(ControlRender, {
              "when-visible": "",
              timeout: 5000,
              "when-prerender": "",
              "visibility-top-margin": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ContentHomeReadyToGetStarted))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})